<template>
  <div class="change-password-page text-center" >
<div class="text-center">
  <label>نسخه {{version}}</label>
</div>
    <br>
<div class="text-center" v-on:click="call()">
  <label>62948 <v-icon >mdi-phone</v-icon></label>
</div>
    <br>
<div class="text-center" v-on:click="website()">
  <label>zoodkomak.com <v-icon >mdi-web</v-icon></label>
</div>


  </div>

</template>
<script>
  export default {
    data(){
      return {
        version :process.env.VUE_APP_APP_VERSION,
        sms_code: '',
        new_pass: '',
        repeat_pass: '',
        error: []
      }
    },
    mounted() {

    },
    methods: {
call(){
  window.open('tel:62948');
},
      website(){
        window.open('zoodkomak.com');

      }

    }

  }
</script>
